import {Operator, User} from "../../models";
import {VoucherTemplateGroup} from "../../models/voucherTemplateGroup";

export class Discount {
    id?: string;
    operator: Operator;
    name: string;
    value: number;
    minimalQuantityOfProducts?: number;
    minimalQuantityOfVouchers?: number;
    minimalQuantityOfLines?: number;
    availableOneTimeFirstDay: boolean;
    canConnect: boolean;
    type: string;
    netPriceDiscount: boolean;
    grossPriceDiscount: boolean;
    fromDate?: string;
    toDate?: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string;
    deletedBy?: User;
    createdBy: User;
    updatedBy: User;
    voucherGroups?: VoucherTemplateGroup[];
}
